import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=52f7393a&scoped=true&"
import script from "./Diamond.vue?vue&type=script&lang=js&"
export * from "./Diamond.vue?vue&type=script&lang=js&"
import style0 from "./Diamond.vue?vue&type=style&index=0&id=52f7393a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7393a",
  null
  
)

export default component.exports